import { useProfileCompletionLevel } from "PFApp/use_profile_completion_level";
import ProgressBar from "PFComponents/progress_bar/progress_bar";
import React from "react";

import css from "./profile_completion_bar.module.scss";

export const ProfileCompletionBar = () => {
  const { completionValue: value, completionColor: color } = useProfileCompletionLevel();

  return <ProgressBar values={[{ value, color }]} totalValue={100} className={css.progressBar} />;
};
